<div class="auth-container">

  <div class="auth-card">

    <h2 class="auth-title">Nueva contraseña</h2>

    <p class="auth-subtitle">
      Ingresá tu nueva contraseña para continuar.
    </p>

    <form (ngSubmit)="reset(f)" #f="ngForm" novalidate>

      <div class="form-group">
        <label>Contraseña</label>
        <input
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="password"
          #passwordInput="ngModel"
          [ngClass]="{ 'is-invalid': passwordInput.invalid && (passwordInput.dirty || passwordInput.touched || f.submitted )}"
          required minlength="8"
        >
        <div class="invalid-feedback">
          Mínimo 8 caracteres.
        </div>
      </div>

      <div class="form-group">
        <label>Repetir contraseña</label>
        <input
          type="password"
          class="form-control"
          name="password_confirmation"
          [(ngModel)]="password_confirmation"
          #passwordConfirmationInput="ngModel"
          [ngClass]="{ 'is-invalid': passwordConfirmationInput.invalid && (passwordConfirmationInput.dirty || passwordConfirmationInput.touched || f.submitted) }"
          required appEquals="password"
        >
        <div class="invalid-feedback">
          Las contraseñas deben coincidir.
        </div>
      </div>

      <button type="submit" class="btn btn-success btn-block btn-lg mt-3">
        Guardar contraseña
      </button>

    </form>

  </div>

</div>